export default __webpack_public_path__ + "static/media/voucherGTS2.f26ab9b0.jpg";